export default "__VITE_ASSET__q_K5$_No__"